// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2tSVn","bannerHeading":"_3Magj","formWrapper":"_1ctwc"};